import IrdRateConfig from '@/pages/components/manage/gov/ird-rate/IrdRateConfig';

export default {
    list: IrdRateConfig,
};
